// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MzIpo","form":"styles_form__aCD2L","btns":"styles_btns__O3W1O"};